module.exports = __webpack_public_path__ + "static/media/sausage-truck-smoke.f4e9a7c4.svg";